export const invoiceDetails = [
  {
    checkbox: true,
    invoice_id: "Inv-001",
    image_url:"assets/img/users/user-39.jpg",
    client_name: "Michael Walker",
    position:"CEO",
    company_name: "BrightWave Innovations",
    created_date: "15/01/2024",
    due_date: "14/01/2024",
    amount:"$3000",
    status:"Paid",
    key: "1"
  },
  {
    checkbox: true,
    invoice_id: "Inv-002",
    image_url:"assets/img/users/user-40.jpg",
    client_name: "Sophie Headrick",
    position:"Manager",
    company_name: "Stellar Dynamics",
    created_date: "21/01/2024",
    due_date: "25/01/2024	",
    amount:"$2500",
    status:"Sent",
    key: "2"
  },
  {
    checkbox: true,
    invoice_id: "	Inv-003",
    image_url:"assets/img/users/user-41.jpg",
    client_name: "Cameron Drake",
    position:"Director",
    company_name: "Quantum Nexus",
    created_date: "20/02/2024	",
    due_date: "22/02/2024	",
    amount:"$2800",
    status:"Partially Paid",
    key: "3"
  },
  {
    checkbox: true,
    invoice_id: "Inv-004",
    image_url:"assets/img/users/user-42.jpg",
    client_name: "Doris Crowley",
    position:"Consultant",
    created_date: "15 Mar 2024",
    company_name: "EcoVision Enterprises",
    due_date: "17 Mar 2024",
    amount:"$3300",
    status:"Sent",
    key: "4"
  },
  {
    checkbox: true,
    invoice_id: "Inv-005",
    image_url:"assets/img/users/user-43.jpg",
    client_name: "Thomas Bordelon",
    position:"Manager",
    company_name: "Aurora Technologies",
    created_date: "12 Apr 2024",
    due_date: "16 Apr 2024",
    amount:"$3600",
    status:"Paid",
    key: "5"
  },
  {
    checkbox: true,
    invoice_id: "Inv-006",
    image_url:"assets/img/users/user-44.jpg",
    client_name: "Kathleen Gutierrez",
    position:"Director",
    company_name: "BlueSky Ventures",
    created_date: "20 Apr 2024",
    due_date: "21 Apr 2024",
    amount:"$2000",
    status:"Partially Paid",
    key: "6"
  },
  {
    checkbox: true,
    invoice_id: "Inv-007",
    image_url:"assets/img/users/user-45.jpg",
    client_name: "Bruce Wright",
    position:"CEO",
    company_name: "TerraFusion Energy",
    created_date: "06 Jul 2024",
    due_date: "06 Jul 2024",
    amount:"$3400",
    status:"Sent",
    key: "7"
  },
  {
    checkbox: true,
    invoice_id: "Inv-008",
    image_url:"assets/img/users/user-46.jpg",
    client_name: "Estelle Morgan",
    position:"Manager",
    company_name: "UrbanPulse Design",
    created_date: "02 Sep 2024",
    due_date: "04 Sep 2024",
    amount:"$4000",
    status:"Paid",
    key: "8"
  },
  {
    checkbox: true,
    invoice_id: "Inv-009",
    image_url:"assets/img/users/user-47.jpg",
    client_name: "Stephen Dias",
    position:"CEO",
    company_name: "Nimbus Networks",
    created_date: "15 Nov 2024",
    due_date: "15 Nov 2024",
    amount:"$4500",
    status:"Partially Paid",
    key: "9"
  },
  {
    checkbox: true,
    invoice_id: "Inv-010",
    image_url:"assets/img/users/user-48.jpg",
    client_name: "Angela Thomas",
    position:"Consultant",
    company_name: "Epicurean Delights",
    created_date: "10 Dec 2024",
    due_date: "11 Dec 2024",
    amount:"$3800",
    status:"Paid",
    key: "10"
  },

];
